import { Box, Typography } from "@material-ui/core";
import { useState } from "react";
import AddressInput from "./AddressInput";
import ResultPaper from "./ResultPaper";

export default function MergeWallet({ ...props }) {
  const [newAddress, setNewAddress] = useState("");

  return (
    <Box {...props}>
      <Typography variant="h4">Trial Of Cross-chain Identification</Typography>
      <AddressInput {...{ setNewAddress }} />
      <ResultPaper {...{ newAddress, setNewAddress }} />
    </Box>
  );
}
